<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';

import { formatDuration } from '~/common/DateUtils';

import { HACKATHONS_START } from './transcendDates';

const ONE_SECOND_MS = 1000;

const countdownText = ref('');
const countdownTimer = ref<ReturnType<typeof setInterval> | null>(null);

const updateCountdown = (): void => {
  const remaining = HACKATHONS_START.getTime() - Date.now();

  if (remaining > 0) {
    countdownText.value = `Hackathons start in: ${formatDuration(remaining)}`;
  } else {
    countdownText.value = 'Hackathons are live!';
  }
};

onBeforeUnmount(() => {
  if (countdownTimer.value) {
    clearInterval(countdownTimer.value);
  }
});

onMounted(() => {
  updateCountdown();
  countdownTimer.value = setInterval(updateCountdown, ONE_SECOND_MS);
});
</script>

<template>
  <div class="mx-auto p-2 mt-3 text-center">
    <h3 class="fw-light">{{ countdownText }}</h3>
  </div>
</template>
